import {WdiCardTitle, wdiCore} from '@/components/WdiControls';
import { WdiPanel } from '@/components/WdiControls/WdiPanel';
import { WdiTable } from '@/components/WdiControls/WdiTable';
import { Enum } from '@/enums/system';
import React, { useEffect, useState } from 'react';

const columns = [
  {
    title: '修改时间',
    key: 'modifiedDate',
    dataIndex: 'modifiedDate',
    with: "200px",
    render: (_: any, record: API.ProductPolicyHistory) => (
      <a onClick={() => {
        window.open('/policy/productpolicyapproval/history/' + `?policyType=${record.policyType}&productPolicyHistoryId=${record.productPolicyHistoryId}`);
      }} data-key={record.productPolicyHistoryId}>
        { wdiCore.Date.MinuteToString(record.modifiedDate)}
      </a>
    )
  },
  {
    title: '修改人',
    key: 'modifiedUserName',
    dataIndex: 'modifiedUserName',
    with: "200px"
  },
  {
    title: '政策说明',
    key: 'remark',
    dataIndex: 'remark',
    with: "300px"
  }
];

type ProductPolicySoldToGridProps = {
  dataSource: API.ProductPolicySoldToQueryPo[];
  onChange?: (dataSource?: any) => void;
};

const ProductPolicyHistoryForApprovalPanel: React.FC<ProductPolicySoldToGridProps> = (
  props: ProductPolicySoldToGridProps,
) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { dataSource, } = props;
  useEffect(() => {
    setIsLoaded(true);
  }, [dataSource]);

  return (
    <>
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.POLICY_HISTORY} title='政策变更历史' />}
        extra={<></>}
      >
        {isLoaded &&
          <WdiTable columns={columns} dataSource={dataSource} pagination={false}/>
        }
      </WdiPanel>
    </>
  );
};

export default ProductPolicyHistoryForApprovalPanel;
